import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Container, Typography, CircularProgress, Paper, Button } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "rgba(10, 10, 10, 0.95)",
    color: "#fff"
  },
  paper: {
    padding: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "rgba(25, 25, 35, 0.7)",
    backdropFilter: "blur(10px)",
    borderRadius: 20,
    border: "1px solid rgba(255, 255, 255, 0.1)",
    boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.5)",
    maxWidth: 400,
    textAlign: "center"
  },
  iconSuccess: {
    fontSize: 80,
    color: "#4caf50",
    marginBottom: theme.spacing(2)
  },
  iconError: {
    fontSize: 80,
    color: "#f44336",
    marginBottom: theme.spacing(2)
  },
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1)
  },
  button: {
    marginTop: theme.spacing(4),
    background: "linear-gradient(135deg, #00C6FF 0%, #0072FF 100%)",
    color: "#fff",
    padding: "10px 30px",
    borderRadius: 30,
    fontWeight: "bold",
    boxShadow: "0 4px 15px rgba(0, 198, 255, 0.4)",
    "&:hover": {
      background: "linear-gradient(135deg, #0072FF 0%, #00C6FF 100%)",
      boxShadow: "0 6px 20px rgba(0, 198, 255, 0.6)"
    }
  }
}));

const OAuthCallback = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const statusParam = params.get("status");
    const messageParam = params.get("message");

    if (statusParam === "success") {
      setStatus("success");
    } else if (statusParam === "error") {
      setStatus("error");
      setErrorMessage(messageParam || "Error desconocido de autenticación.");
    }
  }, [location]);

  return (
    <Container className={classes.root} maxWidth={false}>
      <Paper className={classes.paper}>
        {status === "loading" && (
          <>
            <CircularProgress size={60} style={{ color: "#00C6FF", marginBottom: 20 }} />
            <Typography variant="h5" className={classes.title}>
              Conectando Cuenta...
            </Typography>
            <Typography variant="body1" color="textSecondary">
              Estamos validando tus credenciales con el proveedor. Por favor espera un momento.
            </Typography>
          </>
        )}

        {status === "success" && (
          <>
            <CheckCircleIcon className={classes.iconSuccess} />
            <Typography variant="h5" className={classes.title}>
              ¡Cuenta Conectada!
            </Typography>
            <Typography variant="body1" style={{ color: "#aaa" }}>
              Tu cuenta de correo ha sido sincronizada exitosamente mediante OAuth2.
            </Typography>
            <Button
              className={classes.button}
              onClick={() => history.push("/emails")}
            >
              Volver a Correos
            </Button>
          </>
        )}

        {status === "error" && (
          <>
            <ErrorIcon className={classes.iconError} />
            <Typography variant="h5" className={classes.title}>
              Error de Conexión
            </Typography>
            <Typography variant="body1" style={{ color: "#aaa" }}>
              No se pudo sincronizar tu cuenta. El proveedor devolvió: {errorMessage}
            </Typography>
            <Button
              className={classes.button}
              onClick={() => history.push("/emails")}
              style={{ background: "#444", boxShadow: "none" }}
            >
              Volver e Intentar de Nuevo
            </Button>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default OAuthCallback;
